import { LIST_OF_GET_PARAMS_TO_SAVE } from 'src/common/config'

export default () => {
  storeQueryParams()
}

function storeQueryParams() {
  const params = new Proxy(new URLSearchParams(window.location.search), {
    get: (searchParams, prop) => searchParams.get(prop),
  })

  for (const param of Object.keys(LIST_OF_GET_PARAMS_TO_SAVE)) {
    const paramValue = params[param]
    if (paramValue) {
      try {
        const storage = LIST_OF_GET_PARAMS_TO_SAVE[param]
        storage.setItem(param, paramValue)
      } catch (e) {
        console.error(e)
      }
    }
  }
}
